<div
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="100"
  [attr.aria-valuenow]="clamp(progress, 0, 100) | number:'1.0-2'"
  [attr.aria-valuetext]="(clamp(progress, 0, 100) | number:'1.0-2') + ' ' + (progressText)"
  class="container"
  role="progressbar"
  [opacTooltip]="(clamp(progress, 0, 100) | number:'1.0-2') + ' ' + (progressText)"
>
  <svg preserveAspectRatio="xMidYMid meet" focusable="false" aria-hidden="true" viewBox="0 0 100 100">
    <circle class="spinner-track" fill="none" cx="50%" cy="50%" r="45" stroke-width="6"></circle>
    <circle #spinnerProgress class="spinner" cx="50%" cy="50%" r="45"></circle>
  </svg>

  <span class="content">
    <ng-content></ng-content>
  </span>
</div>
